export const stateName = 'consent';